export default "__VITE_ASSET__39ddbd75__"